import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faChartLine } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../../constants';

import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarController 
} from 'chart.js';

Chart.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend, BarController);

const ShelterLossChart = () => {
  const chartRef = useRef(null);
  const [chartData, setChartData] = useState({ labels: [], currentMonthData: [], lastMonthData: [] });
  const navigate = useNavigate();

  const fetchShelterLossData = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/shelters/shelter-losses`);
      let { shelterLosses } = response.data;

      // Sort by current month loss descending
      shelterLosses = shelterLosses.sort((a, b) => 
        (b.stateLossMonthToDate || 0) - (a.stateLossMonthToDate || 0)
      );

      const labels = [];
      const currentMonthData = [];
      const lastMonthData = [];

     for (const shelter of shelterLosses) {
  labels.push(shelter.shelterName);

  // Ensure current month loss is non-negative
  const currentLoss = shelter.stateLossMonthToDate > 0 ? shelter.stateLossMonthToDate : 0;
  currentMonthData.push(currentLoss);

  // Fetch last month data and ensure it's non-negative
  try {
    const res = await axios.get(`${BASE_URL}/shelters/${shelter._id}/last-month-loss`);
    const lastMonthLoss = res.data?.loss || 0;
    lastMonthData.push(lastMonthLoss > 0 ? lastMonthLoss : 0);
  } catch (err) {
    console.error(`Error fetching last month loss for shelter ${shelter._id}`, err);
    lastMonthData.push(0); 
  }
}

      setChartData({ labels, currentMonthData, lastMonthData });

    } catch (error) {
      console.error('Error fetching shelter loss data:', error);
    }
  };

  useEffect(() => {
    fetchShelterLossData();
  }, []);

  useEffect(() => {
    if (chartData.labels.length) {
      const ctx = document.getElementById('shelterLossChart').getContext('2d');

      if (chartRef.current) {
        chartRef.current.destroy();
      }

      chartRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: chartData.labels,
          datasets: [
            {
              label: 'Last Month Loss (€)',
              data: chartData.lastMonthData,
              backgroundColor: 'rgba(206, 38, 38, 0.9)',  
              borderColor: 'rgba(255, 0, 0, 1)',         
              borderWidth: 1,
              borderRadius: 10,
              barThickness: 25,
            }
            ,
            {
              label: 'This Month Loss (€)',
              data: chartData.currentMonthData,
              backgroundColor: 'rgba(255, 99, 132, 0.6)',
              borderColor: 'rgba(255, 99, 132, 1)',
              borderWidth: 1,
              borderRadius: 10,
              barThickness: 25,
            },
          
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'top',
              labels: {
                color: '#444',
                font: {
                  size: 12,
                  weight: 'bold',
                },
              },
            },
            tooltip: {
              backgroundColor: 'rgba(0,0,0,0.7)',
              titleColor: '#fff',
              bodyColor: '#fff',
            },
          },
          scales: {
            x: {
              ticks: { color: '#666' },
              grid: { display: false },
            },
            y: {
              ticks: { color: '#666' },
              grid: { color: 'rgba(200,200,200,0.2)' },
            },
          },
        },
      });

      return () => {
        if (chartRef.current) {
          chartRef.current.destroy();
        }
      };
    }
  }, [chartData]);

  const handleNavigate = () => {
    navigate('/state/all-shelter-losses');
  };

  return (
    <div className="card shadow-lg rounded" style={{ border: "none", minHeight: "420px" }}>
  <div className="card-body d-flex flex-column">
    <div className="d-flex justify-content-between align-items-center mb-2">
      <h5 className="card-title d-flex align-items-center mb-0 text-dark fw-bold">
        <FontAwesomeIcon icon={faChartLine} className="me-2 text-primary" />
        Shelter Loss
      </h5>
      <div
        className="d-flex align-items-center"
        onClick={handleNavigate}
        style={{ cursor: "pointer" }}
      >
        <p className="mb-0">
          View details <span className="fw-bold">→</span>
        </p>
      </div>
    </div>

 
    <div className="flex-grow-1 position-relative" style={{ overflowX: "auto" }}>
      <div
        style={{
          minWidth: `${chartData.labels.length * 100}px`, 
          height: "100%",
          minHeight: "300px",
        }}
      >
        <canvas id="shelterLossChart"></canvas>
      </div>
    </div>
  </div>
</div>


  );
};

export default ShelterLossChart;
